jQuery(document).ready(function ($) {
    var $product_composition_checkboxes = $(
        '.single-product-composition input[type="checkbox"]'
    );

    if (!$product_composition_checkboxes.length) return;

    var $button_add_to_cart = $('.single-product-add-to-cart form button[type="submit"]');

    $button_add_to_cart.attr("disabled", true);

    $product_composition_checkboxes.on('change', function () {
        var countCheckedCheckboxes =
            $product_composition_checkboxes.filter(":checked").length;

        if (countCheckedCheckboxes >= Number(product_elements.quantity_max)) {
            $product_composition_checkboxes.not(":checked").attr("disabled", true);
        } else {
            $product_composition_checkboxes.not(":checked").attr("disabled", false);
        }

        if (countCheckedCheckboxes < product_elements.quantity_min) {
            $button_add_to_cart.attr("disabled", true);
        } else {
            $button_add_to_cart.attr("disabled", false);
        }

        $(".box-title #count").text(`${countCheckedCheckboxes} de ${product_elements.quantity_max}`);
    });
});
